class CodogotchiPets extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll("[data-codogotchi-pet-button]"));
    this.panels = Array.from(this.querySelectorAll("[data-codogotchi-pet-panel]"));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => this.selectPet(tab));
      tab.addEventListener("keydown", (event) => this.handleKeydown(event, index));
    });
  }

  selectPet(tab) {
    const petId = tab.dataset.petId;

    this.tabs.forEach((item) => {
      const isSelected = item === tab;
      item.setAttribute("aria-selected", String(isSelected));
      item.tabIndex = isSelected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.petId !== petId;
    });
  }

  handleKeydown(event, currentIndex) {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;

    event.preventDefault();
    let nextIndex = currentIndex;

    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = this.tabs.length - 1;

    this.selectPet(this.tabs[nextIndex]);
    this.tabs[nextIndex].focus();
  }
}

if (!customElements.get("codogotchi-pets-selector")) {
  customElements.define("codogotchi-pets-selector", CodogotchiPets);
}
